// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"674":"fb43a7c6","787":"443af9ec"}[chunkId] + ".chunk.js";
};